// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalDocumentsTips {
  width: 890px;
}
.ModalDocumentsTips svg {
  flex-shrink: 0;
}
.ModalDocumentsTips-header {
  color: var(--color_neutral_0);
}
.ModalDocumentsTips-header-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: var(--color_neutral_0);
}
.ModalDocumentsTips-body-card-list {
  display: flex;
  gap: 16px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.ModalDocumentsTips-body-card-list-item {
  display: flex;
  flex-direction: column;
  background-color: var(--color_neutral_900);
  padding: 20px;
  border-radius: 8px;
  gap: 16px;
}
.ModalDocumentsTips-body-card-list-item-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--color_neutral_0);
}
.ModalDocumentsTips-body-card-list-item-body {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--color_neutral_0);
  line-height: 1.5;
}
.ModalDocumentsTips-footer-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 20px;
  background-color: var(--color_neutral_900);
  border-radius: 8px;
  gap: 20px;
}
.ModalDocumentsTips-footer-box-title {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--color_neutral_0);
  line-height: 21px;
}
.ModalDocumentsTips-footer-box-action {
  display: flex;
  align-items: center;
  padding: 9px 12px;
  background-color: var(--color_primary_500);
  color: var(--color_neutral_0);
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  gap: 5px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.ModalDocumentsTips-footer-box-action:hover {
  background-color: #7c3ae6;
  transform: scale(1.02);
}`, "",{"version":3,"sources":["webpack://./src/modules/documents/modal-documents-tips/modal-documents-tips.styles.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,cAAA;AACJ;AAEE;EACE,6BAAA;AAAJ;AACI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AACN;AAII;EACE,aAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAFN;AAGM;EACE,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;AADR;AAEQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AAAV;AAEQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;AAAV;AAOI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,SAAA;AALN;AAMM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;AAJR;AAMM;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,0CAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AAJR;AAKQ;EACE,yBAAA;EACA,sBAAA;AAHV","sourcesContent":[".ModalDocumentsTips {\n  width: 890px;\n\n  svg {\n    flex-shrink: 0;\n  }\n\n  &-header {\n    color: var(--color_neutral_0);\n    &-title {\n      margin: 0;\n      font-size: 24px;\n      font-weight: 600;\n      color: var(--color_neutral_0);\n    }\n  }\n\n  &-body {\n    &-card-list {\n      display: flex;\n      gap: 16px;\n      margin: 0;\n      padding: 0;\n      list-style: none;\n      &-item {\n        display: flex;\n        flex-direction: column;\n        background-color: var(--color_neutral_900);\n        padding: 20px;\n        border-radius: 8px;\n        gap: 16px;\n        &-title {\n          margin: 0;\n          font-size: 16px;\n          font-weight: 700;\n          color: var(--color_neutral_0);\n        }\n        &-body {\n          margin: 0;\n          font-size: 14px;\n          font-weight: 400;\n          color: var(--color_neutral_0);\n          line-height: 1.5;\n        }\n      }\n    }\n  }\n\n  &-footer {\n    &-box {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      padding: 20px;\n      background-color: var(--color_neutral_900);\n      border-radius: 8px;\n      gap: 20px;\n      &-title {\n        margin: 0;\n        font-size: 14px;\n        font-weight: 400;\n        color: var(--color_neutral_0);\n        line-height: 21px;\n      }\n      &-action {\n        display: flex;\n        align-items: center;\n        padding: 9px 12px;\n        background-color: var(--color_primary_500);\n        color: var(--color_neutral_0);\n        border: none;\n        border-radius: 4px;\n        font-size: 14px;\n        font-weight: 400;\n        gap: 5px;\n        cursor: pointer;\n        transition: all 0.2s ease;\n        flex-shrink: 0;\n        &:hover {\n          background-color: #7c3ae6;\n          transform: scale(1.02);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
